var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.33301V12.6663",
  stroke: "#3A414C",
  strokeWidth: 1.5,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.33398 8H12.6673",
  stroke: "#3A414C",
  strokeWidth: 1.5,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.9dcd2e36.svg";